import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane, } from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import fetchMethodRequest from '../../../config/service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import showToasterMessage from '../../UI/ToasterMessage/toasterMessage';
import configMessages from '../../../config/configMessages';
import Loader from './Loader';
import JSZip from 'jszip';
import config from '../../../config/config';
import { marked } from 'marked';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { BeatLoader } from 'react-spinners'
import { FileAskQuestion } from './FileAskQuestion';
import FilePredictNow from './FilePredictNow';
import apiCalls from '../../../config/apiCalls';
import dateUtils from '../../UI/FormatDate/formatDate'
import CustomeTable from '../CommonModals/CustomeTable';

const Dropzone = (props) => {
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({ totalFiles: 0, uploadedFiles: 0 });
    const [isLoaderVisible, setIsLoaderVisible] = useState(false);
    const scrollContainerRef = useRef(null);
    const foldersEndRef = useRef(null);
    let isThrottled = useRef(false)

    const filePropertyFields = [
        { label: 'Name', field: "name" },
        { label: 'Size', field: "size" },
        { label: 'Type', field: "extension" },
        { label: 'Created By', field: "createdByName" },
        { label: 'Updated By', field: "updatedByName" },
        { label: 'Created On', field: "createdDate", type: 'date' },
        { label: 'Last Modified On', field: "modifiedDate", type: 'date' },
    ];

    const folderPropertyFields = [
        { label: 'Name', field: "name" },
        { label: 'Size', field: "size" },
        { label: 'Type', field: "type" },
        { label: 'Total Files', field: "noOfFiles" },
        { label: 'Created By', field: "createdByName" },
        { label: 'Updated By', field: "updatedByName" },
        { label: 'Created On', field: "createdDate", type: 'date' },
        { label: 'Last Modified On', field: "modifiedDate", type: 'date' },
    ];

    const propertyFields = props.fileType === "folder" ? folderPropertyFields : filePropertyFields;

    const getVersionFields = [
        {
            name: "name",
            type: "text",
            placeholder: "Name",
            label: "Name",
            header: "Name",
            width: '10%',
            id: "name",
            displayinaddForm: "true",
            displayineditForm: "true",
            displayinlist: "true",
            controllerName: null,
            fieldType: "redirectable",
            fileViewType: 'view',
            textAlign: "left",
            globalSearchField: "true",
            show: true,
            field: "name",
            isFieldRequired: "false",
            mobile: true,
            displayInSettings: true,
            tDisplay: true,
            displayIcon: true,
            fieldTypes: 'fileUpload',
            filter: true,
            redirectFilterField: 'parentFolderId',
            redirecTo: 'myDocuments',
            // iconName : 'folder',
            showIcon: true,
        },
        {
            name: "version",
            type: "text",
            label: "Version",
            width: "20%",
            header: "Version",
            capitalizeTableText: false,
            sortable: false,
            filter: false,
            id: "version",
            displayinaddForm: "true",
            displayineditForm: "true",
            displayinregisterForm: "",
            displayinlist: "true",
            required: false,
            controllerId: null,
            textAlign: "left",
            show: true,
            field: "fileVersionName",
            displayInSettings: true,
            tDisplay: true,
            fieldType: 'customType',
            customFieldType: 'version',
            style: {
                textAlign: "center",
            },
        },
        // {
        //   name: "createdByName",
        //   type: "Text",
        //   placeholder: "Created By",
        //   label: "Created By",
        //   width: 120,
        //   header: "Created By",
        //   id: "createdByName",
        //   displayinlist: "true",
        //   globalSearchField: "true",
        //   controllerId: 1001,
        //   fieldType: "Text",
        //   textAlign: "left",
        //   show: true,
        //   field: "createdByName",
        //   mobile: true,
        //   filter: true,
        //   displayInSettings: true,
        //   displayinaddForm: "false",
        //   displayineditForm: "false",
        //   isFieldRequired: "false",
        //   tDisplay: true,
        //   customWidth : 'col-md-6 col-sm-12 pl-0',
        //   designIcon : 'user',
        // },
        {
            name: "created",
            type: "date",
            placeholder: "Created",
            label: "Created",
            width: "10%",
            header: "Created",
            derivedValue: "created=undefined",
            actions: [],
            actionsNumber: [],
            id: "created",
            displayinaddForm: "true",
            displayineditForm: "true",
            displayinlist: "true",
            globalSearchField: "true",
            controllerId: null,
            fieldType: "Date",
            // dateFormat: config.dateFormat,
            dateFormat: config.recentDateFormat,

            textAlign: "center",
            disabled: true,
            show: true,
            field: "created",
            isFieldRequired: "false",
            mobile: true,
            displayInSettings: false,
            // tDisplay: true,
        },
        // {
        //     name: "size",
        //     fieldName: "size",
        //     type: "text",
        //     placeholder: "Size",
        //     value: "",
        //     label: "Size",
        //     width: "20%",
        //     addFormOrder: 10,
        //     editFormOrder: 10,
        //     stringType: null,
        //     header: "Size",
        //     derivedValue: "size=undefined",
        //     capitalizeTableText: false,
        //     sortable: false,
        //     filter: false,
        //     id: "size",
        //     displayinaddForm: "true",
        //     displayineditForm: "true",
        //     displayinregisterForm: "",
        //     displayinlist: "true",
        //     isFieldRequired: "false",
        //     required: false,
        //     globalSearchField: "true",
        //     controllerId: null,
        //     isClickable: "",
        //     isAddToIndex: false,
        //     textAlign: "left",
        //     show: true,
        //     field: "size",
        //     showOrHideFields: [],
        //     mobile: true,
        //     displayInSettings: true,
        //     tDisplay: true,
        //     fieldType: 'customType',
        //     customFieldType: 'memoryConversion',
        //     customWidth: 'col-md-6 col-sm-12',
        //     style: {
        //         width: '100%',
        //         textAlign: "center",
        //     },
        // },
    ];

    const onDrop = useCallback((acceptedFiles) => {
        const hasFolder = acceptedFiles.some(file => file.path && file.path.includes('/'));
        const initialFiles = acceptedFiles.map(file => ({
            name: file.name,
            progress: 0,
            status: 'uploading'
        }));
        setFiles(initialFiles);
        setIsLoaderVisible(true);
        setUploadProgress({ totalFiles: acceptedFiles.length, uploadedFiles: 0 });

        if (hasFolder) {
            handleFolderDrop(acceptedFiles);
        } else {
            handleFilesUpload(acceptedFiles);
        }
    }, []);

    useEffect(() => {
        if (props.onRef) {
            props.onRef({
                setFiles,
                setIsLoaderVisible,
                setUploadProgress,
                updateFileStatus
            })
        }
    }, []);

    const handleFilesUpload = (files) => {
        const bytesPerMB = 1024 * 1024;
        const maxFileSize = 2 * 1024 * 1024;
        const oversizedFiles = files.filter(file => file.size >= maxFileSize);

        if (oversizedFiles.length > 0) {
            oversizedFiles.forEach(file => {
                showToasterMessage(
                    `Each file must be less than ${maxFileSize / bytesPerMB} MB`,
                    'error'
                );
            });

            return;
        }
        files.forEach((file, index) => {

            const formData = new FormData();
            formData.append('file', file);
            let url = '';

            const folderData = sessionStorage.getItem("currentFolder");
            const assingValueToForm = folderData ? JSON.parse(folderData) : null;

            const path = assingValueToForm?.path?.slice(22) || props?.assingValueToForm?.path || "";
            const parentID = assingValueToForm?._id || props?.assingValueToForm?.parentFolderId || "";

            let assingValue = { path, parentFolderId: parentID };

            if (path && parentID) {
                url = `files?path=${path}&folderId=${parentID}&type=files&check=no`;
            } else {
                url = 'files?check=no';
            }

            fetchMethodRequest("POST", url, formData, 'upload', true, assingValue)
                .then(async (response) => {
                    if (response?.fileExists) {
                        const payload = { method: 'POST', url: url, data: file, type: 'upload', assignValueToForm: props.assingValueToForm };
                        props.getDocumentConfirmation(payload);
                        updateFileStatus(index, 100, 'error');
                        setIsDragging(false)
                    }
                    if (response && response.respMessage && !response?.fileExists) {
                        props.getDataFromServer();
                        showToasterMessage(response.respMessage, 'success');
                        updateFileStatus(index, 100, 'success');
                        setIsDragging(false)
                    } else if (response && response.errorMessage) {
                        props.getDataFromServer();
                        showToasterMessage(response.errorMessage, 'error');
                        updateFileStatus(index, 100, 'error');
                        setIsDragging(false)
                    }
                }).catch(() => {
                    updateFileStatus(index, 100, 'error');
                });
        });
    };

    const handleFolderDrop = useCallback(async (files) => {
        try {
            const zip = new JSZip();
            const filePromises = files.map((file) => {
                const relativePath = file.path.replace(/^\//, '');
                return file.arrayBuffer()
                    .then(fileContent => zip.file(relativePath, fileContent))
                    .catch(error => {
                        console.error('Error processing file:', error);
                        throw error;
                    });
            });

            await Promise.all(filePromises);
            const blob = await zip.generateAsync({ type: "blob" });
            const formData = new FormData();
            formData.append('file', blob, 'uploaded-folder.zip');

            let url = '';
            const folderData = sessionStorage.getItem("currentFolder");
            const assingValueToForm = folderData ? JSON.parse(folderData) : null;

            const path = assingValueToForm?.path?.slice(22) || props?.assingValueToForm?.path || "";
            const parentID = assingValueToForm?._id || props?.assingValueToForm?.parentFolderId || "";

            if (path && parentID) {
                url = `folders/uploadFolder?path=${path}&folderId=${parentID}&type=files`;
            } else {
                url = 'folders/uploadFolder';
            }

            fetchMethodRequest('POST', url, formData)
                .then(async (response) => {
                    if (response && response.respMessage) {
                        props.getDataFromServer();
                        setIsDragging(false);
                        showToasterMessage(response.respMessage, 'success');
                        files.forEach((file, index) => updateFileStatus(index, 100, 'success'));
                    } else if (response && response.errorMessage) {
                        props.getDataFromServer();
                        setIsDragging(false);
                        showToasterMessage(response.errorMessage, 'error');
                        files.forEach((file, index) => updateFileStatus(index, 100, 'error'));
                    }
                })
                .catch((err) => {
                    console.error('Fetch error:', err);
                    showToasterMessage('Upload failed', 'error');
                    files.forEach((file, index) => updateFileStatus(index, 100, 'error'));
                });
        } catch (error) {
            console.error('Error uploading folder:', error);
            showToasterMessage('Upload failed', 'error');
        }
    }, [props.assingValueToForm, props.getDataFromServer]);

    const updateFileStatus = (index, progress, status) => {
        let noOfFiles = 0;
        setFiles(prevFiles => {
            const updatedFiles = [...prevFiles];
            updatedFiles[index].progress = progress;
            updatedFiles[index].status = status;
            noOfFiles = updatedFiles.length
            return updatedFiles;
        });
        setUploadProgress((prevProgress) => ({
            ...prevProgress,
            uploadedFiles: prevProgress.uploadedFiles + 1,
        }));
        if (noOfFiles === index + 1) {
            setTimeout(() => {
                setIsLoaderVisible(false)
            }, config.progressBarClosingTime);
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        onDragEnter: () => setIsDragging(true),
        onDragLeave: () => setIsDragging(false),
        webkitdirectory: true,
    });

    const renderDataSection = () => {
        if (props.viewType === 'Grid')
            return (
                <>
                    {props.folders.length === 0 && props.files.length === 0 && props.contentSearchedFiles?.length == 0 && props.isLoading() ? (
                        <h3 className='text-center align-items-center' style={{ textAlign: 'center' }}>No Data Found</h3>
                    ) : (
                        <div className='renderGridView p-2 mb-2'>
                            {props.folders.length > 0 && (
                                <>
                                    <h3
                                        className="d-flex mt-1 mb-2"
                                        style={{
                                            marginLeft: '3px',
                                            color: "#12225f",
                                            paddingBottom: '2px',
                                            width: 'fit-content',
                                            fontFamily: "Roboto",
                                            fontWeight: '500'
                                        }}
                                    >{(props.type == "Folders" || props.type == "SharedFiles") && "Folders"}</h3>
                                    <div className={props.type === "User" ? "users" : ""}>{props.renderData(props.folders)}</div>
                                    <div ref={foldersEndRef} />
                                </>
                            )}
                            {props?.files?.length > 0 && (
                                <>
                                    {props?.files && (
                                        <h3
                                            className="d-flex mt-1 mb-2"
                                            style={{
                                                marginLeft: '3px',
                                                color: "#12225f",
                                                paddingBottom: '2px',
                                                width: 'fit-content',
                                                fontFamily: "Roboto",
                                                fontWeight: '500'
                                            }}
                                        >
                                            Files
                                        </h3>
                                    )}
                                    <div className='gridView'>{props.renderData(props.files)}</div>
                                </>
                            )}

                            {(props.contentSearchedFiles?.length > 0 && props.getContentFiles) && (
                                <>
                                    <h3
                                        className="d-flex mt-4 mb-2"
                                        style={{
                                            marginLeft: '3px',
                                            color: "#12225f",
                                            paddingBottom: '2px',
                                            width: 'fit-content',
                                            fontFamily: "Roboto",
                                            fontWeight: '500'
                                        }}
                                    >Content Searched Files</h3>
                                    {props.getContentFiles(props.contentSearchedFiles, 'contentFiles')}
                                </>
                            )}
                        </div>
                    )}
                </>
            );
        else
            return (
                <>{props.renderData()}</>
            )
    };

    const renderDropzone = () => {
        return (
            <div {...getRootProps()} style={{ ...dropzoneStyle, ...(isDragActive ? activeStyle : {}), height: props.contentSearchedFiles?.length > 0 ? '26vh' : `mainCard` }}>
                <input {...getInputProps()} ref={fileInputRef} multiple />
                <div ref={scrollContainerRef} onScroll={handleScroll} className={'mainCard ' + (props.viewType === 'Grid' ? 'dropzone-scroll' : '')}>
                    {renderDataSection()}
                </div>
                {/* {isDragActive&& <div className='water-mark'></div>} */}
                {isDragActive && <div className="upload-icon-container">
                    <FontAwesomeIcon
                        icon={isDragActive && "cloud-upload-alt"}
                        size="4x"
                        color={isDragActive ? "rgb(13, 110, 253)" : ''}
                        className={`upload-icon ${isDragActive ? 'animate-cloud' : ''}`}
                    />
                </div>}
                {isDragActive && (
                    <div className="text-icon-container">
                        <div className="dropLocationStyle">
                            <p style={dropTextStyle}>
                                {props.assingValueToForm?.path
                                    ? configMessages.dragExtenction + `${props.assingValueToForm.path.split('/').pop()}`
                                    : configMessages.defaultDragMessage}
                            </p>
                        </div>
                    </div>
                )}
                {isLoaderVisible && (
                    <Loader
                        files={files}
                        totalFiles={uploadProgress.totalFiles}
                        uploadedFiles={uploadProgress.uploadedFiles}
                        uploadedFileNames={uploadProgress.uploadedFileNames}
                        onClose={() => setIsLoaderVisible(false)}
                    />
                )}
            </div>
        );
    };

    const renderContent = () => {
        return (
            <div style={{ padding: '10px' }}>
                <div ref={scrollContainerRef} onScroll={handleScroll} className={'whbgrcolor row ml-lg-0 px-2  pb-3 ' + (props.viewType === 'Grid' ? 'dropzone-scroll' : '')}>
                    {renderDataSection()}
                </div>
            </div>
        );
    };


    const handleScroll = (event) => {
        event.preventDefault()
        if (props.type == "Folders" || props.type == "Files" || props.type == "files") return

        if (isThrottled.current) {
            return;
        }
        const scrollContainer = scrollContainerRef.current;
        const foldersEnd = foldersEndRef.current;

        if (scrollContainer && foldersEnd) {
            const { scrollTop, clientHeight, scrollHeight } = scrollContainer;
            const foldersEndPosition = foldersEnd.offsetTop;

            // Check if the bottom of the visible area has reached the end of the folders
            if ((scrollTop + clientHeight >= foldersEndPosition && props.folderLoading) || ((scrollTop + clientHeight + 1) >= (scrollHeight))) {
                if (props?.allUsersData?.length < props?.totalRecords) {
                    let filter = props?.filterCriteria;
                    filter.page = props.currentPageRef.current + 1;
                    props?.getDataFromServer(filter, 'onScroll')
                    props?.setFilterCriteria(filter);
                    isThrottled.current = true;
                    setTimeout(() => {
                        isThrottled.current = false;
                    }, 300);
                }
            }
        }
    };


    const handleTabChange = (tabName, tab) => {
        props.handleTabChange(tabName)
    }

    const properties = () => {
        const { propertyDetails, versionHistory, activeTab, tabs } = props
        return (
            <>
                <Nav tabs fill pills className="d-flex align-items-center mb-3 w-100 flex-wrap"                >
                    {tabs && tabs.length > 0 ? (
                        <div className="d-flex flex-wrap w-100">
                            {tabs.map((tab, index) => (
                                <div
                                    key={index}
                                    className="col-lg col-md-6 col-sm-6  d-flex position-relative"
                                >
                                    <NavItem className="flex-fill d-flex">
                                        <NavLink
                                            className={`nav-link d-flex align-items-center justify-content-center w-100 ${activeTab === tab.name ? "active" : ""
                                                }`}
                                            active={activeTab === tab.name}
                                            onClick={() => handleTabChange(tab.name, tab)}
                                            style={{
                                                cursor: "pointer",
                                                backgroundColor:
                                                    activeTab === tab.name ? "#12225f" : "#f0f0f0",
                                                borderRadius: 0,
                                                minWidth: 0,
                                                textAlign: "center"
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100 min-width-0">
                                                <FontAwesomeIcon
                                                    icon={tab.icon}
                                                    className={`me-1 me-sm-2 flex-shrink-0 iconsize ${activeTab === tab.name ? "text-white" : ""
                                                        }`}
                                                    color='#12225f'
                                                />

                                                <span
                                                    title={tab.label}
                                                    className={`text-truncate tab-text ${activeTab === tab.name ? "text-white" : "text-muted"
                                                        }`}
                                                >
                                                    {tab.label}
                                                </span>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <NavItem className="w-100">
                            <NavLink className="nav-link disabled d-flex align-items-center justify-content-center">
                                <FontAwesomeIcon icon="exclamation-circle" className="me-2" />
                                No Tabs Found
                            </NavLink>
                        </NavItem>
                    )}
                </Nav>

                {activeTab === "properties" && <TabContent activeTab={activeTab}>
                    {tabs.map((tab, index) => (
                        <TabPane tabId={tab.name} key={index}>
                            {activeTab === tab.name && (
                                <div>
                                    {propertyFields && propertyFields.length > 0 ? (
                                        <div className="row form m-0">
                                            {propertyFields.map((item, i) => {
                                                const value = propertyDetails[item.field];
                                                if (value === undefined || value === null) {
                                                    return null;
                                                }
                                                return (

                                                    <div className="col-12 d-flex mb-2 p-2" key={i}>
                                                        <div className="col-3 font-weight-bold text-start ml-2"> {item.label} </div>
                                                        <div className="col-1">:</div>
                                                        <div className="col-7 text-start textElipsess" title={propertyDetails[item.field]}>
                                                            {item.type === 'date'
                                                                ? dateUtils.formatDate(propertyDetails[item.field], config.fullDateFormat)
                                                                : propertyDetails[item.field]}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : null}
                                </div>
                            )}
                        </TabPane>
                    ))}
                </TabContent>}

                {activeTab === "version" && <TabContent activeTab={activeTab}>
                    <div className='Datatable m-1'>
                        <CustomeTable data={versionHistory} columns={getVersionFields} changeFieldValues={props.changeFieldValues} type={props.type} />
                    </div>
                </TabContent>}

                {activeTab === "askAQuestion" && <TabContent activeTab={activeTab}>
                    <FileAskQuestion fileDetails={props.sidePanelDetails} />
                </TabContent>}
                {activeTab === "predictNow" && <TabContent activeTab={activeTab}>
                    <FilePredictNow fileDetails={props.sidePanelDetails} />
                </TabContent>}
                {activeTab === "summary" && <TabContent activeTab={activeTab}>
                    <div className='message bot summary-message'>
                        <div dangerouslySetInnerHTML={{ __html: props?.sidePanelDetails?.answer ? marked(props?.sidePanelDetails?.answer) : '' }} ></div>
                    </div>
                </TabContent>}
                {/* {activeTab === "summary" &&  && <TabContent activeTab={activeTab}>
                    <div className='message bot summary-message'>
                        <div dangerouslySetInnerHTML={{ __html: props?.sidePanelDetails?.oneLineSummary ? marked(props?.sidePanelDetails?.oneLineSummary) : '' }} ></div>
                    </div>
                </TabContent>} */}

            </>
        );
    }

    return (
        <div className='row pr-0 gx-1'>
            <div className={'px-0' + (props.openSidePanel ? ' col-8' : ' col-12')}>
                {(props.displayName === 'Home' || (props.type === 'SharedFiles' && props.query && props.query.size && props.query.size > 0 && props.folderPermission && props.folderPermission === 'Edit')) ? renderDropzone() : renderContent()}
                {props?.getContentFilesTable && props?.getContentFilesTable()}
            </div>
            {props.openSidePanel && <div className='col-4 side-container' style={{ ...dropzoneStyle, height: props.contentSearchedFiles?.length > 0 ? '70vh' : '70vh' }}>
                <div className='whbgrcolor summary-container ' style={{ width: "100%" }}>
                    <div>
                        <BeatLoader color='#7a70ba' size={20} cssOverride={{ ...loaderStyle }} loading={props.isSidePanelLoading} />
                        <div className='d-flex justify-content-between align-items-center m-2 summary-file-name'>
                            <div className='textElipsess'>{props?.sidePanelDetails?.fileName}</div>
                            <div className='px-2 getcursor'>
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className='pl-1'
                                    data-toggle="tool-tip" title="Close"
                                    onClick={props.closeSidePanel}
                                    style={{
                                        color: '#7a70ba',
                                        fontSize: '1rem'
                                    }} />
                            </div>
                        </div>
                    </div>
                    <div className='pb-1' >
                        {/* {
                            props?.dataType === 'summary' ? <div className='d-flex justify-content-start'>
                                <div className='message bot summary-message'>
                                    <div dangerouslySetInnerHTML={{ __html: props?.sidePanelDetails?.answer ? marked(props?.sidePanelDetails?.answer) : '' }} ></div>
                                </div>
                            </div> : */}
                        <div className='properties-container px-2'> {properties()} </div>
                        {/* } */}
                    </div>
                </div>
            </div>}
        </div>
    );
};

const dropzoneStyle = {
    textAlign: 'center',
    position: 'relative',
};

const loaderStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
};


const activeStyle = {
    backgroundColor: 'rgba(13, 110, 253, 0.1)',
};


const dropTextStyle = {
    color: '#ffff',
    fontWeight: '500',
};

export default Dropzone;
